module.exports = __webpack_public_path__ + "static/media/img2-3.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/N/img2-3.png
// module id = 2449
// module chunks = 3